module.exports = __webpack_public_path__ + "static/media/19.ed34dd20.jpg";